import * as React from "react";
import { useTranslation } from "react-i18next";
import styled, { css } from "styled-components";
import { DEFAULT_PAGE_SIZES } from "hooks/usePaginationQueryParameter";
import SectionComponent from "components/common/Section/SectionComponent";
import { IfPermitted, DataTable, PaginatedList, NoSearchResult, Text } from "components/common";
import FilterRuleEditButton from "components/streams/StreamDetails/output-filter/FilterRuleEditButton";
import { Alert } from "components/bootstrap";
import FilterStatusCell from "./FilterStatusCell";
import FilterActions from "./FilterActions";
export const StyledSectionComponent = styled(SectionComponent)(
  ({ theme }) => css`
    margin-bottom: ${theme.spacings.xs};

    &.content {
      background-color: ${theme.colors.table.row.backgroundHover};
      padding: ${theme.spacings.sm} ${theme.spacings.xxs};
    }

    &.row {
      margin: 0 ${theme.spacings.xxs} ${theme.spacings.sm};
    }

    h2 {
      font-size: ${theme.fonts.size.h3};
    }

    .table > tbody > tr > td {
      vertical-align: middle;
    }

    .table > tbody > tr {
      background-color: transparent;
    }

    .table > thead > tr > th {
      border-bottom-color: ${theme.utils.colorLevel(theme.colors.variant.default, -5)};
      border-bottom-width: 1px;
    }

    .table.striped > tbody > tr:nth-of-type(even) {
      background-color: ${theme.colors.table.row.backgroundStriped};
    }
  `
);
const StyledText = styled(Text)(
  ({ theme }) => css`
    color: ${theme.colors.gray[50]};
  `
);
const _headerCellFormatter = (header) => /* @__PURE__ */ React.createElement("th", null, header);
const buildFilterItem = (destinationType, requiredPermissions) => (filter) => /* @__PURE__ */ React.createElement("tr", { key: filter.id }, /* @__PURE__ */ React.createElement("td", null, filter.title, /* @__PURE__ */ React.createElement(StyledText, null, filter.description)), /* @__PURE__ */ React.createElement("td", null, /* @__PURE__ */ React.createElement(FilterStatusCell, { filterOutputRule: filter })), /* @__PURE__ */ React.createElement("td", null, /* @__PURE__ */ React.createElement(IfPermitted, { permissions: requiredPermissions }, /* @__PURE__ */ React.createElement(FilterActions, { filterRule: filter, destinationType }))));
const FilterRulesList = ({
  streamId,
  destinationType,
  paginatedFilters,
  onPaginationChange,
  requiredPermissions
}) => {
  const { t } = useTranslation("streams");
  const tableHeaders = [t("output_filter.list.header_title"), t("output_filter.list.header_status"), ""];
  const {
    list: filters,
    pagination: { total }
  } = paginatedFilters;
  return /* @__PURE__ */ React.createElement(
    StyledSectionComponent,
    {
      title: t("output_filter.list.title"),
      headerActions: /* @__PURE__ */ React.createElement(IfPermitted, { permissions: requiredPermissions }, /* @__PURE__ */ React.createElement(
        FilterRuleEditButton,
        {
          filterRule: { stream_id: streamId },
          destinationType,
          streamId
        }
      ))
    },
    /* @__PURE__ */ React.createElement(Alert, { bsStyle: "default" }, destinationType === "indexer" ? t("output_filter.list.info_indexer") : t("output_filter.list.info_data_lake")),
    /* @__PURE__ */ React.createElement(
      PaginatedList,
      {
        totalItems: total,
        pageSize: DEFAULT_PAGE_SIZES[0],
        onChange: onPaginationChange,
        useQueryParameter: false,
        showPageSizeSelect: false
      },
      /* @__PURE__ */ React.createElement(
        DataTable,
        {
          id: "filter-list",
          className: "striped",
          rowClassName: "no-bm",
          headers: tableHeaders,
          headerCellFormatter: _headerCellFormatter,
          sortByKey: "title",
          noDataText: /* @__PURE__ */ React.createElement(NoSearchResult, null, t("output_filter.list.no_filters")),
          rows: filters.toJS(),
          dataRowFormatter: buildFilterItem(destinationType, requiredPermissions)
        }
      )
    )
  );
};
export default FilterRulesList;
